import "datatables.net-dt/js/dataTables.dataTables.js";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Modal, } from 'antd';
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Pagination from "../../utils/Pagination";
import ContentLoader from "../../utils/ContentLoader";
import { useState } from "react";
import SearchBy from "../../utils/SearchBy";
import { TableSortHeaders } from "../../utils/TableSortHeaders";
import { formatDateToDMY, formatTime12Hour } from "../../utils/tools";
import { Popover, Tabs } from 'antd';
import UpdateStatusModal from "../modal/UpdateStatusModal";
import { api } from "../../utils/apiClient";

const { confirm } = Modal;

const LeadsTable = ({
      readingplan,
      roles,
      page,
      setPage,
      totalPages,
      totalEntries,
      sort,
      order,
      setOrder,
      setSort,
      search,
      setSearch,
      fetchReadingPlan,
      onView,
      entriesPerPage,
      setEntriesPerPage,
      onDelete
}) => {
      const viewPermissions = useSelector((state) => state.permission.rolePermissions) || [];
      const [loading, setLoading] = useState(false);
      const [isModalOpen, setIsModalOpen] = useState(false);
      const [selectedLead, setSelectedLead] = useState(null);
      const navigate = useNavigate();

      // console.log("leading table ====>", readingplan);

      const headerConfig = [
            { key: "id", label: "ID", sortable: false },
            { key: "name", label: "Name", sortable: false },
            { key: "created_date", label: "Created Date", sortable: false },
            { key: "phone_number", label: "Phone Number", sortable: false },
            { key: "service", label: "Service", sortable: false },
            { key: "status", label: "Status", sortable: false },
            { key: "action", label: "Action", sortable: false },
      ]

      const handleStatusUpdate = async (id, status) => {
            try {
                  console.log("Updating:", id, status);

                  await api.put(`/leads/${id}/status`, {
                        status: status
                  });

                  setIsModalOpen(false);

                  // 🔥 refresh table after update
                  fetchReadingPlan();

            } catch (error) {
                  console.error("Update failed:", error);
            }
      };

      const splitWords = (text) => {
            if (text === "follow_up") {
                  return "follow up"
            } else {
                  return text;
            }
      }

      if (loading) return <ContentLoader />;

      return (
            <div className="card basic-data-table text-sm overflow-x-auto">
                  <div className="card-header responsive-header d-flex justify-content-end align-items-center global-header">
                        <div className="d-flex align-items-center gap-3">
                              {/* Refresh Icon */}
                              <Icon
                                    icon="mdi:refresh"
                                    width="26"
                                    height="26"
                                    className="ms-2 text-lg d-none d-md-inline-flex refresh-icon "
                                    onClick={fetchReadingPlan}
                              />

                              <div className="search-container" style={{ gap: "10px" }}>
                                    <SearchBy
                                          value={search}
                                          onChange={(e) => {
                                                setSearch(e.target.value);
                                                setPage(1);
                                          }}
                                    />
                                    {viewPermissions.includes("readingplan.create") && (
                                          <button
                                                className="btn btn-primary-600 global-add-btn"
                                                type="button"
                                          // onClick={() => navigate("/events-form")}
                                          >
                                                <Icon
                                                      icon="fa6-regular:square-plus"
                                                      className="icon text-lg line-height-1"
                                                />
                                                Add
                                          </button>
                                    )}
                              </div>
                        </div>
                  </div>
                  <div className="card-body card-body-modify">
                        <div className="w-full overflow-x-auto">
                              <table className="table bordered-table mb-0 text-sm w-full min-w-max" id="dataTable">
                                    <thead>
                                          <tr>
                                                {TableSortHeaders(headerConfig, sort, order, setSort, setOrder, setPage)}
                                          </tr>
                                    </thead>
                                    <tbody>
                                          {Array.isArray(readingplan) && readingplan.length > 0 ? (
                                                readingplan.map((item) => (
                                                      <tr key={item.id}>
                                                            <td>
                                                                  {item.id}
                                                            </td>
                                                            <td className="d-flex align-items-center gap-2">
                                                                  <span>{item.name}</span>
                                                            </td>

                                                            <td>
                                                                  {item.created_at
                                                                        ? `${formatDateToDMY(item.created_at)} ${item.created_at ? formatTime12Hour(item.created_at) : ""
                                                                        }`
                                                                        : "-"}
                                                            </td>

                                                            {/* Start Date & Time */}
                                                            <td>
                                                                  {item.phone}
                                                            </td>

                                                            {/*Plan Type */}
                                                            <td>
                                                                  {item.service}
                                                            </td>

                                                            <td>
                                                                  <span
                                                                        className={`px-24 py-4 rounded-pill fw-medium text-sm ${item.status === "follow_up"
                                                                              ? "bg-primary-100 text-primary-600"
                                                                              : item.status === "Interested"
                                                                                    ? "bg-success-focus text-success-main"
                                                                                    : item.status === "Completed"
                                                                                          ? "bg-warning-focus text-warning-main"
                                                                                          : "bg-danger-focus text-danger-main"
                                                                              }`}
                                                                  >
                                                                        {item.status.charAt(0).toUpperCase() + splitWords(item.status).slice(1)}
                                                                  </span>
                                                            </td>

                                                            <td>
                                                                  <div className="d-flex align-items-center justify-content-between">

                                                                        {/* Right Side - Three Dots */}
                                                                        <Popover
                                                                              trigger="click"
                                                                              placement="bottomRight"
                                                                              overlayClassName="action-popover"
                                                                              content={
                                                                                    <div className="action-list">
                                                                                          {viewPermissions.includes("event.edit") && (
                                                                                                <button
                                                                                                      onClick={() => {
                                                                                                            setSelectedLead(item);
                                                                                                            setIsModalOpen(true);
                                                                                                      }}
                                                                                                      className="action-item text-success-main"
                                                                                                >
                                                                                                      <Icon icon="lucide:edit" />
                                                                                                      <span>Edit</span>
                                                                                                </button>
                                                                                          )}

                                                                                          {viewPermissions.includes("event.delete") && (
                                                                                                <button
                                                                                                      className="action-item text-danger-main"
                                                                                                      onClick={() => onDelete(item.id)}
                                                                                                >
                                                                                                      <Icon icon="mingcute:delete-2-line" />
                                                                                                      <span>Delete</span>
                                                                                                </button>
                                                                                          )}
                                                                                    </div>
                                                                              }
                                                                        >
                                                                              {viewPermissions.includes("event.edit") && (
                                                                                    <button
                                                                                          type="button"
                                                                                          className="w-32-px h-32-px bg-neutral-300 rounded-circle border-0 d-inline-flex align-items-center justify-content-center"
                                                                                    >
                                                                                          <Icon icon="mdi:dots-vertical" />
                                                                                    </button>
                                                                              )}
                                                                        </Popover>

                                                                  </div>
                                                            </td>

                                                      </tr>
                                                ))
                                          ) : (
                                                <tr>
                                                      <td colSpan={7} className="text-center">
                                                            No Event found
                                                      </td>
                                                </tr>
                                          )}
                                    </tbody>
                              </table>
                        </div>
                        <Pagination
                              page={page}
                              setPage={setPage}
                              totalPages={totalPages}
                              totalEntries={totalEntries}
                              entriesPerPage={entriesPerPage}
                              setEntriesPerPage={setEntriesPerPage}
                        />
                  </div>
                  <UpdateStatusModal
                        open={isModalOpen}
                        onClose={() => setIsModalOpen(false)}
                        onUpdate={handleStatusUpdate}
                        lead={selectedLead}
                  />
            </div>
      );
};

export default LeadsTable;